// NPM
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';

// ANT COMPONENT
import { Space, Row, Col } from 'antd';
import { Button, Loader } from '@life-line-lab/components-react';

// STYLE
import './order-payment-status.scss';

interface OrderPaymentStatusProps {
  data?: any;
  status?: any;
  resError?: any;
}

const OrderPaymentStatus: React.FC<OrderPaymentStatusProps> = ({
  data,
  status,
  resError
}) => {
  const { t } = useTranslation()
  const history = useHistory();

  const isLoading = status === 'idle' || status === 'loading';
  const isFailed = data.paymentStatus !== 'PAID';
  const isSuccess = data.paymentStatus === 'PAID';

  const initialError = {};
  const [error, setError] = useState<any>(initialError);

  useEffect(() => {
    if (status === 'error' && !isEmpty(resError)) {
      setError({ ...error, general: t(`${resError.value}`) })
    }
  }, [status, resError]);

  console.log({ data });

  return (
    <div className="order-payment-status">
      {isLoading &&
        <Loader size="large" />
      }

      {!isLoading &&
        <Space direction="vertical" size="large">
          <Row gutter={16} className="order-payment-status--container">
            <Col span={24} className="mt-30 mb-30">
              {isSuccess
                ? <img src="/assets/images/success-payment.png" width={200} />
                : <img src="/assets/images/failed-payment.png" width={200} />
              }
            </Col>

            <Col span={24} className="mb-20">
              <h1>
                {!data.paymentStatus
                  ? t('title.paymentPageExpired')
                  : isSuccess
                    ? t('title.paymentSuccess')
                    : t('title.paymentFailed')
                }
              </h1>
            </Col>

            {error.general &&
              <Col span={24} className="mb-20">
                <div style={{ maxWidth: '450px', margin: 'auto' }}>
                  <h3 dangerouslySetInnerHTML={{ __html: error.general }} />
                </div>
              </Col>
            }

            {data.paymentStatus &&
              <Col span={24}>
                <Row gutter={16} style={{ maxWidth: '450px', margin: 'auto' }}>
                  <Col span={24} className="left">
                    <div className="item">
                      <div className="label">{t('label.paymentType')}</div>
                      <div>{data.paymentType ? data.paymentType : ''}</div>
                    </div>
                  </Col>

                  {data.bankName ?
                    <Col span={24} className="left">
                      <div className="item">
                        <div className="label">{t('label.bank')}</div>
                        <div>{data.bankName}</div>
                        {/* <div>{data.bankName ? data.bankName : '-'}</div> */}
                      </div>
                    </Col>
                    :
                    null
                  } 

                  <Col span={24} className="left">
                    <div className="item">
                      <div className="label">{t('label.paymentStatus')}</div>
                      <div>{data.paymentStatus ? t(`option.${data.paymentStatus}`) : ''}</div>
                    </div>
                  </Col>

                  <Col span={24} className="left">
                    <div className="item">
                      <div className="label">{t('label.paymentStatusDescription')}</div>
                      <div>{t(`${data.paymentStatusDescription}`)}</div>
                    </div>
                  </Col>

                  {data.bankReference &&
                    <Col span={24} className="left">
                      <div className="item">
                        <div className="label">{t('label.bankReference')}</div>
                        <div>{data.bankReference}</div>
                      </div>
                    </Col>
                  }

                  <Col span={24} className="left">
                    <div className="item">
                      <div className="label">{t('label.paymentDate')}</div>
                      <div>{moment(data.paymentDate).local().format('YYYY-MM-DD HH:mm:ss')}</div>
                    </div>
                  </Col>

                  <Col span={24} className="left">
                    <div className="item mb-15 mt-15">
                      <div className="label">{t('label.amout')}</div>
                      <div><strong>RM {Number(data.total).toFixed(2)}</strong></div>
                    </div>
                  </Col>

                  <Col span={24} className="left mb-20">
                    <div className="item">
                      <div className="label">{t('label.transactionID')}</div>
                      <div>{data.transactionID ? data.transactionID : '-'}</div>
                    </div>
                  </Col>

                </Row>
              </Col>
            }

            <Col offset={6} span={12}>
              <Button
                className="btn-buy my-10"
                type="primary"
                onClick={()=> history.push('/')}
                label={t('label.orderPayment.backToShop')}
                size="large"
              />
            </Col>
          </Row>
        </Space>
      }
    </div>
  )
}


export default OrderPaymentStatus;
